import { Card, Row, Col, Upload } from "antd";
import React, { useState } from "react";
import { FormItem, Input, Modal, Form, AsumsiIcon } from "asumsi-components";
import ImgCrop from 'antd-img-crop';

export const AggregatorSection = (props: any) => {
    const { setFieldsValues, fieldsValues, getBase64, beforeUpload, onPreview, uploadBanner } = props;

    const initialAdsValues: any = {
        imageUrl: null,
        type: null,
        imageCreditBy: null,
        size: null,
        urlAdds: null,
        orderNumber: 1
    }

    const [fileList, setFileList] = useState([]);
    const [fieldsAdsValues, setFieldsAdsValues]: any = useState(initialAdsValues);
    const [showAddsForm, setShowAdsForm] = useState(false);

    const emptyImage = (type?: string, orderNumber?: number) =>
        <div className={`empty-upload ${type ?? ""}`}
            onClick={() => {
                if (type == "banner") {
                    setFieldsAdsValues({ ...initialAdsValues, size: "small", orderNumber });
                    setShowAdsForm(true);
                } else {
                    setFieldsAdsValues({ ...initialAdsValues, size: "large", orderNumber });
                    setShowAdsForm(true);
                }
            }}
        >
            <Row justify="space-around" align="middle" style={{ height: "100%" }}>
                <Col style={{ height: "100%" }}>
                    <p className="desc">set ads</p>
                </Col>
            </Row>
        </div>;


    const onSaveAds = async () => {
        const existAds: any = fieldsValues.ads ?? [];
        const index: number = fieldsAdsValues.orderNumber ?? 1;
        const finIndex = existAds.findIndex((sec: any) => sec.orderNumber == index);

        const uploadImage: any = await uploadBanner({
            image: fieldsAdsValues.imageAds,
            imageCreditBy: "",
            size: "small",
            type: "ads",
            url: fieldsAdsValues.urlAdds,
        });

        const objectKey: any = {
            type: 'ads',
            id: uploadImage.id,
            orderNumber: index,
            imageUrl: uploadImage.imageUrl,
            title: null,
            excerpt: null,
            topic: null,
            publishDateTime: null
        }
        if (finIndex >= 0) {
            existAds[finIndex] = objectKey;
        } else {
            existAds.push(objectKey);
        }


        setFieldsValues({ ...fieldsValues, ads: existAds });
        setShowAdsForm(false);
    }

    const defaultImageAds = (imageUrl: string) => {
        const onDeleteImage = () => {
            const errors: string[] = ['image'];
            if (!fieldsAdsValues.url) {
                errors.push('urlAdds');
            }
            setFieldsAdsValues({ ...fieldsAdsValues, imageAds: null, imageUrl: null, errors });
            setFileList([]);
        }
        return <div className={`upload-list-item-info ${fieldsAdsValues.size}`}>
            <img src={imageUrl} className="upload-list-item-image"></img>
            <div className="card-actions">
                <div className="actions picture">
                    <AsumsiIcon icon="trash" onClick={onDeleteImage} />
                </div>
            </div>
        </div>
    }

    const emptyImageAds = (widthImage: string, heightImage: string) => <div className={`empty-upload ${fieldsAdsValues.size}`}>
        <Row justify="space-around" align="middle" style={{ height: "100%" }}>
            <Col style={{ height: "100%" }}>
                <p className="size">{`${widthImage}x${heightImage}px`}</p>
                <p className="desc">Click to browse or drag file to this area to upload</p>
            </Col>
        </Row>
    </div>;


    const onChangeImageAds = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        const errors: string[] = [];
        if (newFileList[0]) {
            errors.push('imageAds');
        }

        if (!fieldsAdsValues.url) {
            errors.push('urlAdds');
        }

        setFieldsAdsValues({ ...fieldsAdsValues, imageUrl: newFileList[0].thumbUrl, imageAds: newFileList[0] ? newFileList[0].originFileObj : null, errors })
        setFileList(newFileList);
    };

    const onclickRemoveImage = (orderNumber: number) => {
        const adsExisting: any[] = fieldsValues.ads ?? [];
        const newAds: any[] = adsExisting.filter((sec: any) => sec.orderNumber != orderNumber);
        setFieldsValues({ ...fieldsValues, ads: newAds });
    }

    const defaultImage = (data: any, orderNumber: number, type: string) => {
        let view: any = null;
        if (data.type == "ads") {
            view = <div className={`hero-right-card ${type} display-flex`}>
                <img src={data.imageUrl}></img>
                <div className="card-actions">
                    <div className="actions picture">
                        <AsumsiIcon icon="trash" onClick={() => onclickRemoveImage(orderNumber)} />
                    </div>
                </div>
            </div>;
        } else {
            view = emptyImage(type, orderNumber);
        }
        return view;
    }

    return <Card className="aggregator-card" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div className="title-desc">
            <div className="title">AGGREGATOR SECTION</div>
        </div>
        <Row>
            <FormItem width="100%" className="m-t-10" label="Title" labelAlign="left" fieldsValues={fieldsValues} setFieldsValues={setFieldsValues}
                fieldDecorator={{
                    label: "feedsTitle",
                    rules: [{
                        message: 'Please input title',
                        required: true,
                    }
                    ]
                }}
            >
                <Input id="feedsTitle" defaultValue={fieldsValues.feedsTitle} />
            </FormItem>
        </Row>
        <Row>
            <Col span={14} style={{ display: "flex" }}>
            </Col>
            <Col span={10} style={{ paddingLeft: "36px" }}>
                <Row>
                    <Col span={24}>
                        {fieldsValues.ads && fieldsValues.ads.length > 0 && fieldsValues.ads.filter((ft: any) => ft.orderNumber == 1).length > 0 ? defaultImage(fieldsValues.ads.filter((ft: any) => ft.orderNumber == 1)[0], 1, "banner") : emptyImage("banner", 1)}
                    </Col>
                    <Col span={24}>
                        {fieldsValues.ads && fieldsValues.ads.length > 0 && fieldsValues.ads.filter((ft: any) => ft.orderNumber == 2).length > 0 ? defaultImage(fieldsValues.ads.filter((ft: any) => ft.orderNumber == 2)[0], 2, "banner-large") : emptyImage("banner-large", 2)}

                    </Col>
                    <Col span={24}>
                        {fieldsValues.ads && fieldsValues.ads.length > 0 && fieldsValues.ads.filter((ft: any) => ft.orderNumber == 3).length > 0 ? defaultImage(fieldsValues.ads.filter((ft: any) => ft.orderNumber == 3)[0], 3, "banner") : emptyImage("banner", 3)}
                    </Col>
                </Row>
            </Col>
        </Row>
        <Modal
            key="hero-adds-form"
            show={showAddsForm}
            setShow={setShowAdsForm}
            title='Set adds'
            okText="Save"
            actionBottom={true}
            onOk={onSaveAds}
            className="modal-right-hero"
            onCancel={() => setFieldsAdsValues(initialAdsValues)}
            disableButtonOk={fieldsAdsValues.errors && fieldsAdsValues.errors.length > 0}
        >
            <Card>
                <Form titleBold={true}>
                    <Row gutter={30}>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <FormItem setFieldsValues={setFieldsAdsValues} label="Image" fieldsValues={fieldsAdsValues} labelAlign="left"
                                fieldDecorator={{
                                    label: "imageAds",
                                    rules: [{
                                        message: 'Please upload banner image',
                                        required: true,
                                    }
                                    ]
                                }}
                            >
                                {fieldsAdsValues.imageUrl ? defaultImageAds(fieldsAdsValues.imageUrl) :
                                    <ImgCrop aspect={fieldsAdsValues.size == "small" ? 4 : 1} rotate>
                                        <Upload
                                            listType="picture"
                                            fileList={fileList}
                                            openFileDialogOnClick={true}
                                            onChange={onChangeImageAds}
                                            onPreview={onPreview}
                                            beforeUpload={beforeUpload}
                                        >
                                            {fileList.length == 0 && emptyImageAds("640", fieldsAdsValues.size == "small" ? "160" : "640")}
                                        </Upload>
                                    </ImgCrop>}

                            </FormItem>
                            <FormItem hint="Please include http:// or https:// for outer link" setFieldsValues={setFieldsAdsValues} label="Link" fieldsValues={fieldsAdsValues} labelAlign="left"
                                fieldDecorator={{
                                    label: "urlAdds",
                                    rules: [{
                                        message: 'Please input banner url',
                                        required: true,
                                    }
                                    ]
                                }}
                            >
                                <Input id="urlAdds" key="urlAdds" defaultValue={fieldsAdsValues.urlAdds} />
                            </FormItem>
                            <FormItem setFieldsValues={setFieldsAdsValues} label="Credit By" fieldsValues={fieldsAdsValues} labelAlign="left"
                                fieldDecorator={{
                                    label: "imageCreditBy"
                                }}
                            >
                                <Input id="imageCreditBy" key="imageCreditBy" defaultValue={fieldsAdsValues.imageCreditBy} />
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    </Card>;
}

export default AggregatorSection;


// WEBPACK FOOTER //
// ./src/pages/homepage-form/libraries/aggregatorSection.tsx